import React, { useState, useEffect } from 'react';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import { Button } from 'react-bootstrap5';
import ExternalLink from 'components/Widgets/ExternalLink';
import Actions from '../Actions';

export default function Activities() {
  const [isLoading, setIsLoading] = useState(true);
  const [isPossibleMoreLoad, setIsPossibleMoreLoad] = useState(true);
  const [activities, setActivities] = useState(null);
  const [lastId, setLastId] = useState(null);

  const onLoadMore = () => {
    setIsLoading(true);
    Actions.loadActivity(lastId, (data) => {
      setActivities((prev) => [
        ...(prev || []),
        ...(data.length === 6 ? data.slice(0, -1) : data),
      ]);
      if (data && data.length > 0) {
        setLastId(data[data.length - 1].id);
      }
      if (data.length < 6) {
        setIsPossibleMoreLoad(false);

        setActivities((prev) => [
          ...(prev || []),
          {
            id: 0,
            attributes: {
              event: 'welcome',
              type_activity: 'MEMBER',
              title: 'Hello! Congratulations on taking the first step',
              description: 'This timeline will help track your coaching activity.',
              url: null,
            },
          },
        ]);
      }
      setIsLoading(false);
    });
  };

  useEffect(() => {
    if (activities === null) {
      onLoadMore();
    }
  }, []);

  return (
    <>
      <h3>
        Timeline
      </h3>
      {activities === null && <LoadingPlaceholder text="Loading..." />}

      <div className="timeline">

        {activities && activities.map((item) => (
          <div key={`activity-${item.id}`} className="icon-with-text mt-5">
            <div className="icon-bg bg-gray-200">
              <i className={item.attributes.event === 'welcome'
                ? 'timeline-register-icon bg-secondary-1000' : 'timeline-icon bg-secondary-1000'}
              />
            </div>
            <div className="text-content d-flex justify-content-between w-100">
              <div>
                <p className="text-gray-700">{item.attributes.type_activity.toLowerCase()}</p>
                <h5>{item.attributes.title}</h5>
                <p className="text-gray-700">{item.attributes.description}</p>
              </div>
              {item.attributes.url !== null && (
                <div>
                  <ExternalLink
                    href={item.attributes.url}
                    variant="outline-primary"
                  >
                    Report
                  </ExternalLink>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {isPossibleMoreLoad && (
        <div className="text-center mt-4">
          <Button
            variant="outline-primary"
            className="btn-reverse"
            disabled={isLoading}
            onClick={onLoadMore}
          >
            Show More
          </Button>
        </div>
      )}

    </>
  );
}
